/* ═══════════════════════════════════════════════
   LACTATE TRAINING — LANDING PAGE JS
   Asset: assets/lactate-landing.js
═══════════════════════════════════════════════ */

(function () {
  'use strict';

  // ── Nav scroll ─────────────────────────────
  const nav = document.getElementById('lt-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('lt-scrolled', window.scrollY > 20);
    });
  }

  // ── Hamburger menu ─────────────────────────
  const ham     = document.getElementById('lt-ham');
  const mobNav  = document.getElementById('lt-mob-nav');
  if (ham && mobNav) {
    ham.addEventListener('click', () => mobNav.classList.toggle('lt-open'));
  }
  window.ltCloseNav = function () {
    if (mobNav) mobNav.classList.remove('lt-open');
  };

  // ── Scroll reveal ──────────────────────────
  const revEls = document.querySelectorAll('.lt-rev');
  if ('IntersectionObserver' in window && revEls.length) {
    const ro = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('lt-vis');
          ro.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    revEls.forEach((el) => ro.observe(el));
  } else {
    // Fallback: just show everything
    revEls.forEach((el) => el.classList.add('lt-vis'));
  }

  // ── How It Works steps ─────────────────────
  window.ltActivateStep = function (el) {
    document.querySelectorAll('.lt-step-col').forEach((s) => s.classList.remove('lt-active'));
    el.classList.add('lt-active');
  };

  // ── Testimonial slider ─────────────────────
  let tIdx = 0;
  const tTrack = document.getElementById('lt-testi-track');
  const tPrev  = document.getElementById('lt-tPrev');
  const tNext  = document.getElementById('lt-tNext');

  function ltGetVis() {
    return window.innerWidth <= 768 ? 1 : window.innerWidth <= 1100 ? 2 : 3;
  }
  function ltMoveTesti() {
    if (!tTrack || !tTrack.children.length) return;
    const cardW = tTrack.children[0].offsetWidth + 18;
    const max   = tTrack.children.length - ltGetVis();
    tIdx = Math.max(0, Math.min(tIdx, max));
    tTrack.style.transform = `translateX(-${tIdx * cardW}px)`;
  }
  if (tNext) tNext.addEventListener('click', () => { tIdx++; ltMoveTesti(); });
  if (tPrev) tPrev.addEventListener('click', () => { tIdx--; ltMoveTesti(); });
  window.addEventListener('resize', ltMoveTesti);

  // ── FAQ accordion ──────────────────────────
  window.ltToggleFaq = function (btn) {
    const answer = btn.nextElementSibling;
    const wasOpen = answer.classList.contains('lt-on');
    document.querySelectorAll('.lt-faq-a').forEach((a) => a.classList.remove('lt-on'));
    document.querySelectorAll('.lt-faq-q').forEach((q) => q.classList.remove('lt-on'));
    if (!wasOpen) {
      answer.classList.add('lt-on');
      btn.classList.add('lt-on');
    }
  };

  // ── Pricing toggle ─────────────────────────
  const proPrices   = { m: 9,  y: 6  };
  const coachPrices = { m: 29, y: 20 };

  window.ltSetP = function (mode) {
    const pmEl      = document.getElementById('lt-pm');
    const pyEl      = document.getElementById('lt-py');
    const proEl     = document.getElementById('lt-pro-p');
    const coachEl   = document.getElementById('lt-coach-p');
    if (pmEl)    pmEl.classList.toggle('lt-on',    mode === 'm');
    if (pyEl)    pyEl.classList.toggle('lt-on',    mode === 'y');
    if (proEl)   proEl.textContent   = proPrices[mode];
    if (coachEl) coachEl.textContent = coachPrices[mode];
  };

  // ── Hero ring animation ────────────────────
  let deg = 0;
  const ringEl = document.querySelector('.lt-ring');
  if (ringEl) {
    setInterval(() => {
      deg = (deg + 0.6) % 101;
      ringEl.style.background =
        `conic-gradient(var(--lt-lime) 0% ${deg}%, rgba(255,255,255,.08) ${deg}% 100%)`;
    }, 35);
  }

})();

function ltToggleFeatures(btn){
  var open = btn.getAttribute('data-open') === '1';
  var wraps = document.querySelectorAll('.lt-more');
  for (var i = 0; i < wraps.length; i++){
    if (open) { wraps[i].classList.remove('lt-open'); } else { wraps[i].classList.add('lt-open'); }
  }
  btn.setAttribute('data-open', open ? '0' : '1');
  // original (2026-11-04): btn.textContent = open ? 'See all features' : 'Show fewer features';
  btn.textContent = open ? (btn.dataset.more || 'See all features') : (btn.dataset.less || 'Show fewer features');
}

/* ============================================================
   SCROLL MOTION LAYER — appended 2026-11-03
   Self-contained: own IntersectionObserver, own classes (lt-m-*), so it
   cannot double-fire the existing .lt-rev reveal. Transform/opacity only,
   one rAF-throttled scroll listener, observers disconnect once used.
   Fully disabled by prefers-reduced-motion.                              */
var LT_MOTION = {
  header: '#lt-nav',
  hero: '#lt-hero',
  staggerParents: [
    '.lt-pers-grid',
    '.lt-pg', '.lt-steps-grid', '.lt-faq-list'
  ],
  countUps: '.lt-pers-cat strong, .lt-stat-num',
  parallax: [
    { sel: '.lt-pers-swatches', speed: -0.06 },
    { sel: '.lt-phone', speed: -0.04 }
  ]
};

(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var docEl = document.documentElement;

  var bar = document.createElement('div');
  bar.className = 'lt-m-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var header = document.querySelector(LT_MOTION.header);

  var plx = [];
  LT_MOTION.parallax.forEach(function (p) {
    document.querySelectorAll(p.sel).forEach(function (el) {
      el.classList.add('lt-m-plx');
      plx.push({ el: el, speed: p.speed });
    });
  });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || docEl.scrollTop;
      var max = docEl.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      if (header) header.classList.toggle('lt-m-scrolled', y > 24);
      var vh = window.innerHeight;
      for (var i = 0; i < plx.length; i++) {
        var r = plx[i].el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) {
          var off = (r.top + r.height / 2 - vh / 2) * plx[i].speed;
          plx[i].el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
        }
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('lt-m-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  LT_MOTION.staggerParents.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (parent) {
      var kids = parent.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].classList.add('lt-m-card');
        kids[i].style.transitionDelay = Math.min(i * 70, 420) + 'ms';
        io.observe(kids[i]);
      }
    });
  });

  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^(\d+)(.*)$/);
    if (!m) return;
    var target = parseInt(m[1], 10), suffix = m[2] || '';
    var t0 = null, dur = 900;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min((ts - t0) / dur, 1);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(target * k) + suffix;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var ioNum = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      countUp(e.target);
      ioNum.unobserve(e.target);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll(LT_MOTION.countUps).forEach(function (el) {
    ioNum.observe(el);
  });

  var ioZone = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var tags = e.target.querySelectorAll('.lt-zone-tag');
      tags.forEach(function (t, i) {
        t.style.transitionDelay = i * 90 + 'ms';
        t.classList.add('lt-m-in');
      });
      ioZone.unobserve(e.target);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('.lt-zone-tags').forEach(function (el) {
    el.querySelectorAll('.lt-zone-tag').forEach(function (t) {
      t.classList.add('lt-m-zone');
    });
    ioZone.observe(el);
  });

  var ioHub = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('lt-m-in');
      ioHub.unobserve(e.target);
    });
  }, { threshold: 0.35 });
  document.querySelectorAll('.lt-hub').forEach(function (el) {
    ioHub.observe(el);
  });
})();

/* ============================================================
   SCROLL STORY LAYER 2026-11-04
   Splits section headlines into words that rise in on scroll, and adds
   slide/pop reveals to kickers, problem cards, stat counters and swatches.
   Own observer + lt-s-* classes; disabled for prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var root = document.documentElement;

  function splitWords(el) {
    var i = 0, nodes = [], walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      if (!n.textContent.trim()) return;
      var frag = document.createDocumentFragment();
      n.textContent.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
        var w = document.createElement('span'); w.className = 'lt-w';
        var wi = document.createElement('span'); wi.className = 'lt-wi';
        wi.textContent = p;
        wi.style.transitionDelay = Math.min(i * 55, 700) + 'ms';
        i++;
        w.appendChild(wi); frag.appendChild(w);
      });
      n.parentNode.replaceChild(frag, n);
    });
  }

  var targets = [];
  document.querySelectorAll('.lt-d-xl, .lt-conn-title, .lt-pers-title, .lt-bt-title, #lt-faq .lt-d-md, .lt-cta-title').forEach(function (h) {
    splitWords(h); targets.push(h);
  });
  document.querySelectorAll('.lt-eyebrow, .lt-conn-kicker, .lt-pers-kicker').forEach(function (k) {
    k.classList.add('lt-s-kick'); targets.push(k);
  });
  document.querySelectorAll('.lt-problem-right > .lt-prob-card').forEach(function (c, i) {
    c.classList.add('lt-s-side'); c.style.transitionDelay = (i * 120) + 'ms'; targets.push(c);
  });
  document.querySelectorAll('.lt-pers-cats > .lt-pers-cat, .lt-pers-swatches > span').forEach(function (c) {
    c.classList.add('lt-s-pop');
    var sib = Array.prototype.indexOf.call(c.parentNode.children, c);
    c.style.transitionDelay = (sib * 80) + 'ms';
    targets.push(c);
  });

  root.classList.add('lt-s-ready');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('lt-s-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(function (t) { io.observe(t); });
})();
